// file: `react/src/components/chatscopeAvatar.ts`:

export function chatscopeAvatarSrc(label) {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40">
    <rect width="40" height="40" rx="20" fill="%236c757d"/>
    <text x="20" y="26" text-anchor="middle" font-size="18" fill="white">${label || '?'}</text>
  </svg>`;
  return `data:image/svg+xml;utf8,${svg}`;
}
